module.exports = __webpack_public_path__ + "static/media/UWE_Bristol.ada4db75.webp";